// A request lists existing lines, which addSalesOrderItem and imports can grow past the booking cap, so it is bounded separately.
export const MAX_SALES_ORDER_LINE_LIST = 5000;
//# sourceMappingURL=max-sales-order-line-list.js.map